import * as React from 'react';
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import {lazyInject} from "@athena-portal/core";
import {
    ICustomerPortalService,
    PartyProperty,
    PartyPropertyEnum,
    Policy,
    Quote,
    Subscription,
    Types
} from "@falcon/services";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {HomeInsuranceQuotesPanel} from "./HomeInsuranceQuotesPanel";
import {authorize, Overlay} from "@athena-portal/components";
import {shouldRedirectToAllianzOnlinePage} from "../../../../CommonFunctions";
import {Navigate} from "react-router-dom";

interface IState {
    quotes?: Quote[];
    policies?: Policy[];
    subscription? : Subscription;
    doRedirectToAllianzOnlinePage: boolean;
}

@authorize
export class HomeInsuranceQuotesPage extends React.Component<{}, IState> {

    private pluginTemplates = new PluginTemplates();

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    constructor(props: Readonly<{}>) {
        super(props);
        this.state = {
            doRedirectToAllianzOnlinePage: false,
        }
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Your home insurance quotes");
        this.customerPortalService
            .getQuotes()
            .subscribe((quotes: Quote[]) => {
                    this.setState({quotes});
                    if (window.location.pathname.includes("/dashboard")) {
                        this.setRedirectToAllianzOnlinePage(quotes);}
                }
            );

        this.customerPortalService
            .getUserPoliciesWithLatestVersions()
            .subscribe((policies: Policy[]) => {
                this.setState({policies});

            if (policies && policies.length > 0) {
                this.customerPortalService.getSubscription().subscribe((subscription: Subscription) => {
                    this.setState({subscription});
                });
            }
        });
    }

    public render() {
        const {policies, quotes, subscription} = this.state;

        if (quotes && policies) {
            return (
                <React.Fragment>
                    {(this.doRedirectToAllianzOnlinePage()) && (<Navigate to={`/allianzOnline?product=HomeInsurance`}/>)}
                    <FalconHeader/>
                    <HomeInsuranceQuotesPanel
                        quotes={quotes}
                        isActivePoliciesPresent={policies.length > 0}
                        policies={policies}
                        subscription={subscription}/>
                    <FalconFooter/>
                </React.Fragment>
            )
        } else {
            return <Overlay show={true}/>
        }
    }

    private async setRedirectToAllianzOnlinePage(quotes: Quote[]) {
        const partyProperty = await this.fetchPartyPropertyByPropertyKey(PartyPropertyEnum.ALLIANZ_ONLINE_SHOWN);
        const shouldRedirect = await shouldRedirectToAllianzOnlinePage(
            quotes,
            partyProperty
        );

        this.setState({
            doRedirectToAllianzOnlinePage: shouldRedirect
        });
    }

    private async fetchPartyPropertyByPropertyKey(key: PartyPropertyEnum): Promise<PartyProperty> {
        const observable = this.customerPortalService.getPartyPropertyByPropertyKey(key);
        return await observable.toPromise();
    }

    private readonly doRedirectToAllianzOnlinePage = (): boolean => {
        if (this.state.doRedirectToAllianzOnlinePage) {
            this.setState({doRedirectToAllianzOnlinePage: false});
            return true;
        }

        return false;
    }
}
